module.exports = __webpack_public_path__ + "img/subscription2.14efcffd.png";